// @ts-nocheck
// 加密密钥（16、24 或 32 字节

const key = new TextEncoder().encode('yKSZ:%-8ftIVwdPA');

const getKey = async (algorithm) => {
  return window.crypto.subtle.importKey('raw', key, algorithm, false, ['encrypt', 'decrypt']);
};
/**
 * aes-128-gcm 加密
 * @returns 加密后的字符串,16进制
 * @param json
 */
export const encrypt = async (json): Promise<any> => {
  const data = JSON.stringify(json);
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const algorithm = { name: 'AES-GCM', iv, tagLength: 128 };
  const cryptoKey = await getKey(algorithm);
  return new Promise((resolve, reject) => {
    const plainText = new TextEncoder().encode(data);
    window.crypto.subtle
      .encrypt(algorithm, cryptoKey, plainText)
      .then((cipherText) => {
        const u8en = new Uint8Array(cipherText);
        const result = Uint8Array.from([...iv, ...u8en]);
        const base64 = byteArrayToBase64(result.buffer);
        resolve(base64);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
const byteArrayToBase64 = (byteArray) => {
  const uint8Array = new Uint8Array(byteArray);
  return window.btoa(String.fromCharCode.apply(null, uint8Array));
};
const base64ToBinary = (base64) => {
  try {
    const binaryString = window.atob(base64);
    const binaryData = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      binaryData[i] = binaryString.charCodeAt(i);
    }
    return binaryData;
  } catch (error) {
    return base64;
  }
};

/**
 * aes-128-gcm 解密
 * @returns
 * @param base64
 */
export const decrypt = async (base64): Promise<any> => {
  const encryptedData = await base64ToBinary(base64);
  const u8 = encryptedData;
  const iv = u8.slice(0, 12);
  const content = u8.slice(12);
  const algorithm = { name: 'AES-GCM', iv, tagLength: 128 };
  const key = await getKey(algorithm);
  return new Promise((resolve, reject) => {
    window.crypto.subtle
      .decrypt(algorithm, key, content)
      .then((decryptedData) => {
        const plainText = new TextDecoder().decode(decryptedData);
        try {
          const jsonData = JSON.parse(plainText);
          resolve(jsonData);
        } catch (error) {
          resolve(plainText);
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
